import { CardHistoricoProps } from "../../Base/types";
import CardHistoricoBase from "../../Base/CardHistoricoBase";
import { BookCheck, LucideIcon } from "lucide-react";
import ExpandedContent from "./ExpandedContent";

const detectarCienciaProfissional = (acao: string): boolean => {
    const texto = (acao || "").toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");

    return texto.includes("deu ciencia na orientacao") || 
           (texto.includes("retornou orientacao") && texto.includes("aguardando ciencia"));
};

const obterIconeCienciaProfissional = (_acao: string): { Icon: LucideIcon; color: string } => {
    return { Icon: BookCheck, color: "var(--c28a745)" };
};

export default function CardCienciaProfissional({
    item,
    onNavigateToFile,
    isExpanded,
    onToggleExpand
}: CardHistoricoProps) {
    return (
        <CardHistoricoBase
            item={item}
            icon={obterIconeCienciaProfissional(item.acao)}
            temExpansaoDisponivel={true}
            isExpanded={isExpanded}
            onToggleExpand={onToggleExpand}
            expandedContent={<ExpandedContent item={item} onNavigateToFile={onNavigateToFile} />}
        />
    );
}

export const cienciaProfissionalConfig = {
    tipo: "ciencia_profissional",
    detectaTipo: detectarCienciaProfissional,
    getIcon: obterIconeCienciaProfissional,
    temExpansao: () => true,
    Component: CardCienciaProfissional
};


